import classNames from 'classnames';
import React from 'react';
import NestableLink from '../utils/NestableLink';
import * as styles from './Card.module.scss';

export const CardSeparator = () => <hr className={styles.separator} />;

interface CardsProps {
  children: React.ReactNode;
}

export const Cards = ({ children }: CardsProps) => (
  <div className={styles.cards}>{children}</div>
);

type CardProps = {
  children: React.ReactNode;
  to?: string;
  onClick?: () => void;
  noPadding?: boolean;
  newTab?: boolean;
  'aria-label'?: string;
} & Partial<
  Pick<
    React.ComponentProps<typeof NestableLink>,
    'onClick' | 'to' | 'ignoreInsideLinks'
  >
>;

const Card = ({
  children,
  ignoreInsideLinks,
  noPadding = false,
  onClick,
  to,
  'aria-label': ariaLabel,
  newTab,
}: CardProps) => {
  const innerClassName = classNames(styles.card, {
    [styles.clickable]: to || onClick,
    [styles.noPadding]: noPadding,
  });

  if (to) {
    return (
      <NestableLink
        className={innerClassName}
        ignoreInsideLinks={ignoreInsideLinks}
        onClick={onClick}
        newTab={newTab}
        to={to}
        aria-label={ariaLabel}
      >
        {children}
      </NestableLink>
    );
  }
  if (onClick) {
    return (
      <button className={innerClassName} onClick={onClick} type="button">
        {children}
      </button>
    );
  }

  return <div className={innerClassName}>{children}</div>;
};

export default Card;
